export enum ArticleHeroPillarVariant {
  HERO_PILLAR = 'Hero Pillar',
  SIMPLE_HERO = 'Simple Hero'
}
